"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = exports.TriggerWrapper = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SecondaryButton = _interopRequireDefault(require("../Buttons/SecondaryButton/SecondaryButton.styled"));

var _tokens = _interopRequireDefault(require("../Tokens/tokens"));

var _utils = require("../utils");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var font = _tokens.default.font;

var TriggerWrapper = _styledComponents.default.div.withConfig({
  displayName: "TriggerWrapper",
  componentId: "sc-nk2jhx-0"
})(["display:contents;"]);

exports.TriggerWrapper = TriggerWrapper;

var StyledModal = _styledComponents.default.div.withConfig({
  displayName: "StyledModal",
  componentId: "sc-nk2jhx-1"
})(["position:relative;width:60%;min-height:4rem;max-width:", ";z-index:2001;background-color:white;border-radius:.5rem;display:flex;flex-direction:column;justify-content:center;@media (max-width:768px){width:80%;justify-content:flex-start;}@media (max-width:480px){background-color:#f4f6fa;", ";}"], function (props) {
  return "small" === props.size ? "34rem" : "50rem";
}, function (props) {
  return props.mobileFullScreen && (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n            width: 100%;\n            height: 100%;\n            border-radius: 0;\n        "])));
});

StyledModal.propTypes = {
  mobileFullScreen: _propTypes.default.bool,
  isConfirmation: _propTypes.default.bool
};
StyledModal.Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-nk2jhx-2"
})(["overflow-y:auto;"]);
StyledModal.Header = _styledComponents.default.div.withConfig({
  displayName: "Header",
  componentId: "sc-nk2jhx-3"
})(["padding:2rem 2rem 1rem 2rem;font-weight:500;", ";@media (max-width:480px){padding:1.25rem 2.5rem 1.25rem 1.25rem;}", ""], function (props) {
  return props.justifyContent && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n        justify-content: ", ";\n    "])), props.justifyContent);
}, function (props) {
  return props.slidingPanel && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)(["\n        border-bottom: solid 1px rgba(200, 200, 200, 0.5);\n    "])));
});
StyledModal.Header.propTypes = {
  slidingPanel: _propTypes.default.bool,
  justifyContent: _propTypes.default.string
};
StyledModal.Title = _styledComponents.default.span.withConfig({
  displayName: "Title",
  componentId: "sc-nk2jhx-4"
})(["font-size:", ";font-weight:", ";"], (0, _utils.pxToRem)(font.size.xxl), font.weight.bold);
StyledModal.Body = _styledComponents.default.div.withConfig({
  displayName: "Body",
  componentId: "sc-nk2jhx-5"
})(["padding:1rem 2rem;", ";@media (max-width:480px){padding:1rem 1.25rem;}"], function (props) {
  return props.textAlign && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteralLoose2.default)(["\n        text-align: ", ";\n    "])), props.textAlign);
});
StyledModal.Footer = _styledComponents.default.div.withConfig({
  displayName: "Footer",
  componentId: "sc-nk2jhx-6"
})(["padding:1rem 2rem 2rem 2rem;display:", ";justify-content:", ";@media(max-width:480px){padding:1.5rem;}"], function (props) {
  return props.display || "flex";
}, function (props) {
  return props.justifyContent || "space-around";
});
StyledModal.Footer.propTypes = {
  justifyContent: _propTypes.default.string,
  display: _propTypes.default.string
};
StyledModal.DismissButton = _styledComponents.default.button.withConfig({
  displayName: "DismissButton",
  componentId: "sc-nk2jhx-7"
})(["position:absolute;right:0;top:0;width:4rem;height:4rem;cursor:pointer;display:flex;justify-content:center;align-items:center;background:none;border:none;"]);
StyledModal.ConfirmationButton = (0, _styledComponents.default)(_SecondaryButton.default).withConfig({
  displayName: "ConfirmationButton",
  componentId: "sc-nk2jhx-8"
})(["font-size:1rem;font-weight:500;border:1px solid #C4D0D6;@media(max-width:480px){width:100%;}"]);
var _default = StyledModal;
exports.default = _default;